<template>
  <div class="tcu-article _content tcu-directory">
    <transition name="slide-fade" mode="out-in">
      <div v-if="selectedView === 'results'">
        <header
          class="tcu-results-filter"
          :class="{ '_no-filters': config.filters == '' }"
        >
          <template v-if="config.filters">
            <button
              class="tcu-results-filter__menu-trigger"
              :class="{ '_is-active': filterOpen }"
              @click="toggleFilters"
            >
              <div class="filter _label">
                Filters
                <span v-if="numberOfFilters">({{ numberOfFilters }})</span
                ><img
                  width="15"
                  height="9"
                  alt="Open Accordion"
                  src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='15px' height='9px' viewBox='0 0 27 17' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 52.5 (67469) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3Eslider arrow copy 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Program-D-Math' transform='translate(-1039.000000, -3726.000000)' fill='%234D4D4A' stroke='%234D4D4A' stroke-width='1.96'%3E%3Cg id='slider-arrow' transform='translate(1052.500000, 3734.000000) rotate(-90.000000) translate(-1052.500000, -3734.000000) translate(1044.500000, 3721.500000)'%3E%3Cpath d='M13.5324837,24.8310811 C13.312616,24.8310811 13.09215,24.7563214 12.9189481,24.6054125 L0.519904875,13.8072257 C0.189654598,13.5193037 0,13.0724132 0,12.5810559 C0,12.0896987 0.189654598,11.6428081 0.519904875,11.3548861 L12.9189481,0.556699337 C13.2803089,0.241541468 13.8483753,0.258772321 14.1873006,0.594496048 C14.526226,0.930497691 14.5079784,1.45826206 14.1463185,1.77314201 L2.68089039,11.7586995 C2.16936142,12.2039226 2.16936142,12.9581893 2.68089039,13.4034123 L14.1463185,23.3892477 C14.5079784,23.7038498 14.526226,24.2316141 14.1873006,24.5676158 C14.0108082,24.7427035 13.7717955,24.8310811 13.5324837,24.8310811' id='Fill-1'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A"
                  data-state=""
                  class="tcu-down-arrow"
                />
              </div>
            </button>
            <filter-list @closeFilters="toggleFilters"></filter-list>
          </template>

          <div class="tcu-results-filter__heading tcu-visually-hidden">
            <div class="tcu-results-filter__search">
              <label
                class="screen-reader-text tcu-visuallyhidden"
                for="directory-keyword-search"
                >Search for:</label
              >
              <input
                type="search"
                value
                name="s"
                id="directory-keyword-search"
                placeholder="Who can we help you find?"
                v-model="search"
                v-on:keyup="getfilteredData"
                autocorrect="off"
              />
              <input type="submit" value="Search" @click="getfilteredData" />
            </div>
          </div>

          <div class="tcu-view-selector tcu-visually-hidden">
            <p class="tcu-view-selector__option _label">
              <button
                v-bind:class="{ active: layout == 'grid' }"
                v-on:click="gridView"
              >
                View Grid
                <img
                  height="10"
                  width="10"
                  alt=""
                  class="tcu-down-arrow"
                  src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 21.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 12 12' style='enable-background:new 0 0 12 12;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23111111;%7D%0A%3C/style%3E%3Ctitle%3EGroup%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1'%3E%3Cg id='Program-List-links' transform='translate(-1468.000000, -545.000000)'%3E%3Cg id='Group' transform='translate(1468.000000, 545.000000)'%3E%3Crect id='Rectangle' class='st0' width='5' height='5'/%3E%3Crect id='Rectangle_1_' y='7' class='st0' width='5' height='5'/%3E%3Crect id='Rectangle_2_' x='7' class='st0' width='5' height='5'/%3E%3Crect id='Rectangle_3_' x='7' y='7' class='st0' width='5' height='5'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A"
                />
              </button>
            </p>
            <p class="tcu-view-selector__option _label">
              <button
                v-bind:class="{ active: layout == 'list' }"
                v-on:click="listView"
              >
                View List
                <img
                  height="15"
                  width="15"
                  alt=""
                  class="tcu-down-arrow"
                  src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 21.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 16 10' style='enable-background:new 0 0 16 10;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23111111;stroke-linecap:square;%7D%0A%3C/style%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1'%3E%3Cg id='Program-List-links' transform='translate(-1637.000000, -545.000000)'%3E%3Cg id='Group-3' transform='translate(1638.000000, 545.000000)'%3E%3Cpath id='Line' class='st0' d='M4,0.5h10'/%3E%3Cpath id='Line_1_' class='st0' d='M0,0.5h1'/%3E%3Cpath id='Line_2_' class='st0' d='M4,3.5h10'/%3E%3Cpath id='Line_3_' class='st0' d='M0,3.5h1'/%3E%3Cpath id='Line_4_' class='st0' d='M4,6.5h10'/%3E%3Cpath id='Line_5_' class='st0' d='M0,6.5h1'/%3E%3Cpath id='Line_6_' class='st0' d='M4,9.5h10'/%3E%3Cpath id='Line_7_' class='st0' d='M0,9.5h1'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A"
                />
              </button>
            </p>
          </div>
        </header>
        <!-- End .tcu-results-filter -->

        <div
          v-if="loaded === true && filteredData.length < 1"
          class="tcu-callout _warning"
        >
          <p>No profiles match your current filter selections.</p>
        </div>
        <div v-if="loaded === false">
          <p>Please wait while we fetch our directory information for you.</p>
        </div>

        <!-- Grouped Directory List -->
        <template v-if="filteredData.length >= 1 && config.groups !== 'none'">
          <template v-for="group in groupedData">
            <div
              v-if="group.data.length"
              :key="group.value"
              class="tcu-results-listing tcu-fadeIn"
              v-bind:class="{
                _grid: layout === 'grid',
                _list: layout === 'list'
              }"
            >
              <h2>{{ group.name }}</h2>
              <ul>
                <component
                  :is="layout === 'grid' ? 'profile-card' : 'profile-list'"
                  v-for="(card, index) in group.data"
                  :key="index"
                  :card="card"
                  v-model="layout"
                  @selectProfile="displayProfile"
                  :focused="card.filename == focusedItem"
                >
                </component>
              </ul>
            </div>
          </template>
        </template>

        <!-- Regular Directory List -->
        <template v-else-if="filteredData.length >= 1">
          <div
            class="tcu-results-listing tcu-fadeIn"
            v-bind:class="{
              _grid: layout === 'grid',
              _list: layout === 'list'
            }"
          >
            <ul>
              <component
                :is="layout === 'grid' ? 'profile-card' : 'profile-list'"
                v-for="(card, index) in filteredData"
                :key="index"
                :card="card"
                v-model="layout"
                @selectProfile="displayProfile"
                :focused="card.filename == focusedItem"
              >
              </component>
            </ul>
          </div>
        </template>

        <!-- End .tcu-results-listing group -->
      </div>

      <profile-details
        v-if="selectedView === 'details' && this.selectedProfile !== null"
        :selectedProfile="selectedProfile"
        :deepLink="deepLink"
        :linkInterests="filterTypes['areasOfInterest']['status']"
        class="slide"
        @closeProfile="closeProfileView"
      ></profile-details>
    </transition>
  </div>
  <!-- End .tcu-article._content .tcu-full-width .tcu-directory -->
</template>

<script>
import store from "../store";
import axios from "axios";
import { debounce, formatId, getURLParam } from "../helpers";
import ProfileCard from "./ProfileCard";
import ProfileList from "./ProfileList";
import ProfileDetails from "./ProfileDetails";
import FilterList from "./FilterList";
import { EventBus } from "../events.js";

export default {
  components: {
    "profile-card": ProfileCard,
    "profile-list": ProfileList,
    "profile-details": ProfileDetails,
    "filter-list": FilterList
  },
  props: {
    // this component expects a prop of type object
    appConfig: Object
  },
  data() {
    return store;
  },
  metaInfo() {
    const title = this.originalPageTitle;
    const canonical = window.page_url || this.originalCanonical;
    let meta = {
      title: title,
      link: []
    };
    if (canonical) {
      meta.link.push({ rel: "canonical", href: canonical, vmid: "canonical" });
    }
    return meta;
  },
  watch: {
    layout(newLayout) {
      localStorage.layout = newLayout;
    }
  },
  created() {
    axios({
      method: "GET",
      url:
        this.config.source.charAt(0) == "/"
          ? "https://www.tcu.edu" + this.config.source
          : this.config.source
    }).then(
      result => {
        this.liveProfileData = result.data;
        this.loaded = true;
        // merge title into keywords
        this.mergeKeywords();
        // check for any query string params
        this.initFilters();
        this.checkForParams();
        this.getfilteredData();
        this.checkURL();
      },
      error => {
        //console.error(error);
      }
    );
    if (localStorage.layout) {
      this.layout = localStorage.layout;
    }
    this.setUpHandlers();
    this.checkWindowSize();
  },
  computed: {
    numberOfFilters: function() {
      let number = 0;
      for (var filter in this.selectedFilters) {
        if (this.selectedFilters.hasOwnProperty(filter)) {
          number += this.selectedFilters[filter].length;
        }
      }
      return number;
    },
    filterParameters: function() {
      var urlFilters = "";
      for (const key in this.selectedFilters) {
        if (this.selectedFilters.hasOwnProperty(key)) {
          const element = this.selectedFilters[key];
          element.forEach(function(name) {
            urlFilters += `&${key}=${encodeURIComponent(name)}`;
          });
        }
      }
      return (urlFilters = urlFilters.replace("&", "?"));
    },
    /**
     * An array used to group directory listings by certain statuses such as role type and teaching status
     * Each group has a display name, an value used for the group match, a type, and a data array
     * @returns {array}
     */
    groupedData: function() {
      // A configured school is required for groups to work
      if (this.config.groups === "none" || !this.config.school) {
        return [];
      }

      // Set groups to simple or advanced based on the config option
      let groups = this.groups[this.config.groups];

      // For every group we want to display, look for matches based on on what type of grouping
      // it is and then add it to that group's data array
      groups.forEach(group => {
        group.data = this.filteredData.filter(data => {
          // Get the person's role for the currently selected school
          let schoolRole = data.roles.find(
            role => role.school.id === this.config.school
          );
          // Check if the person's role type is equal to our group's value
          if (schoolRole && group.type === "role") {
            return schoolRole.type === group.value;
            // Check if the person's teaching status is equal to our group's value
          }
          if (schoolRole && group.type === "teaching-status") {
            return schoolRole["teaching-status"].id === group.value;
          } else {
            return false;
          }
        });
      });

      return groups;
    }
  },
  methods: {
    /**
     * Checks the current url for a requested profile
     */
    checkURL() {
      let currentURL = window.location.pathname;
      let requestedProfile = "";
      if (currentURL.indexOf("view/") !== -1) {
        requestedProfile = currentURL.substring(currentURL.lastIndexOf("/"));
        requestedProfile =
          "https://www.tcu.edu/directory/_data" + requestedProfile + ".json";
        /**
         * Make sure the requested profile is part of the filtered data
         * before trying to display it
         */
        for (let index = 0; index < this.filteredData.length; index++) {
          if (this.filteredData[index].canonical == requestedProfile) {
            this.displayProfile(requestedProfile, false);
            this.deepLink = true;
            break;
          }
        }
      } else {
        this.selectedView = "results";
      }
    },
    /**
     * Sets the selected profile and updates the view
     * @param {string} profile
     */
    displayProfile(profile, focus = true) {
      this.selectedProfile = profile.source || profile;
      this.selectedView = "details";

      this.changeTagName(
        document.querySelector(".tcu-content-wrapper h1"),
        "h2",
        "h1"
      );

      if (focus) {
        this.focusedItem = profile.filename;
      }
    },
    /**
     * Closes the current profile view and returns the user to the results page
     */
    closeProfileView() {
      this.deepLink = false;
      this.selectedProfile = null;
      this.selectedView = "results";
      window.history.pushState({ view: "results" }, "Directory", "../list");

      this.changeTagName(
        document.querySelector(".tcu-content-wrapper h2"),
        "h1",
        "h1"
      );
    },
    /**
     * Changes an element's tagname
     * @param {object} element The element to change
     * @param {string} tag The new tagname
     * @param {string} className A class name to add to the new tag
     */
    changeTagName(element, tag, className) {
      var title = element;
      var newTitle = document.createElement(tag);
      newTitle.innerHTML = title.innerHTML;
      newTitle.classList.add(className);
      title.parentNode.replaceChild(newTitle, title);
    },
    /**
     * When the active history entry changes, check the url to update the state
     */
    popState: function() {
      this.checkURL();
      // check for any query string params
      this.checkForParams();
      this.getfilteredData();
    },
    /**
     * Setup Event Listeners
     */
    setUpHandlers: function() {
      window.addEventListener("popstate", this.popState);
      window.addEventListener("resize", debounce(this.checkWindowSize, 250));
      EventBus.$on("filterChange", list => {
        if (this.selectedFilters[list.id]) {
          this.selectedFilters[list.id] = list.filters;
        }

        history.replaceState(
          null,
          null,
          window.location.pathname.split("?")[0] + this.filterParameters
        );
        this.getfilteredData();
      });
      EventBus.$on("filterReset", () => {
        for (var filter in this.selectedFilters) {
          if (this.selectedFilters.hasOwnProperty(filter)) {
            this.selectedFilters[filter] = [];
          }
        }
      });
    },
    /**
     * Check the screen width on window resize
     */
    checkWindowSize: function() {
      if (window.innerWidth < 700) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    /**
     * Check URL for search and filter parameters
     */
    checkForParams: function() {
      let paramSchools = [];
      let paramDepartments = [];
      let paramSearch = "";
      // check for search keyword
      if (0 < getURLParam("s").length) {
        paramSearch = decodeURIComponent(getURLParam("s"));
        paramSearch = String(paramSearch).replace("+", " ");
        this.search = String(paramSearch).replace(/[^\w-\s]/gi, "");
      }
      // Check for filter types
      for (const key in this.selectedFilters) {
        if (this.selectedFilters.hasOwnProperty(key)) {
          const element = this.selectedFilters[key];
          if (0 < getURLParam(key).length) {
            this.selectedFilters[key] = getURLParam(key);
          }
        }
      }
    },
    /**
     * Change the view to Grid
     */
    gridView: function() {
      this.layout = "grid";
    },
    /**
     * Change the view to List
     */
    listView: function() {
      this.layout = "list";
    },
    /**
     * Change the view to List
     */
    toggleFilters: function() {
      this.filterOpen = !this.filterOpen;
    },
    /**
     * Create selected filter lists by looping over the filter types property
     * A filter might be disabled by setting a status of false
     * Since this object is modified after the vue instance is created, $set must be used for reactivity
     */
    initFilters: function() {
      // Get filters from config object
      let configFilters = this.config.filters.split(",");
      for (let index = 0; index < configFilters.length; index++) {
        const key = configFilters[index];
        if (this.filterTypes.hasOwnProperty(key)) {
          this.filterTypes[key].status = true;
          this.$set(this.selectedFilters, key, []);
        }
      }
    },
    /**
     * Get filtered data based on the search term and filters
     * @param {object} e
     */
    getfilteredData: function(e) {
      this.focusedItem = false;
      if (e && e.which === 13) {
        let searchTerm = this.search;
        let searchLink =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?s=" +
          searchTerm;

        history.pushState(null, null, searchLink);
      }
      this.filteredData = this.liveProfileData.fsprofiles;
      let filteredDataByfilters = [];
      let filteredDataBySearch = [];
      let searchRegEx = "";

      // then filter according to keyword
      if (this.search !== "") {
        let searchRegEx = new RegExp(this.search, "i");
        if (this.search.indexOf(" ") != -1) {
          let searchTerms = this.search.split(" ");
          let multiRE = "^";
          for (var st = 0; st < searchTerms.length; st++) {
            multiRE += "(?=.*" + searchTerms[st] + ")";
          }
          searchRegEx = new RegExp(multiRE, "i");
        }
        filteredDataBySearch = this.filteredData.filter(obj =>
          obj.keywords.match(searchRegEx)
        );
        this.filteredData = filteredDataBySearch;
      }

      // then filter by filter checkboxes
      this.filteredData.forEach(profile => {
        let found = true;
        // Role Based ----
        for (let i = 0; i < profile.roles.length; i++) {
          const role = profile.roles[i];
          // Check College
          // This is not likely to be used but including it for future use
          if (this.filterTypes["school"].status) {
            found = this.checkFilter(found, "school", role, "id");
            if (!found) {
              continue;
            }
          }
          // Check Department
          if (this.filterTypes["departments"].status) {
            found = this.checkFilter(found, "departments", role, "id");
            if (!found) {
              continue;
            }
          }
          // Check Teaching Audience
          if (this.filterTypes["teaching-audiences"].status) {
            found = this.checkFilter(found, "teaching-audiences", role, "id");
            if (!found) {
              continue;
            }
          }
          // Check Teaching Status
          if (this.filterTypes["teaching-status"].status) {
            found = this.checkFilter(found, "teaching-status", role, "id");
            if (!found) {
              continue;
            }
          }
          // Check Office Type
          if (this.filterTypes["office-types"].status) {
            found = this.checkFilter(found, "office-types", role, "id");
            if (!found) {
              continue;
            }
          }
          // Check Areas of Study
          if (this.filterTypes["areas-study"].status) {
            found = this.checkFilter(found, "areas-study", role, "id");
            if (!found) {
              continue;
            }
          }

          if (found) {
            break;
          }
        }
        // Root Based ----
        // Check Areas of Interest (Tags)
        if (found) {
          if (this.filterTypes["areasOfInterest"].status) {
            found = this.checkFilter(found, "areasOfInterest", profile);
          }
        }

        // If the profile matches the filters, add it to the list
        if (found) {
          filteredDataByfilters.push(profile);
        }
      });

      this.filteredData = filteredDataByfilters;
    },
    /**
     * Return the result of checking for a filter
     * @param {boolean} result - for preserving the current result status
     * @param {string} name - the name of the filter type
     * @param {array} array - the array of profile items to search through (profile or role)
     * @param {string} [property] - optional property to test against if the array is of objects instead of strings
     */
    checkFilter: function(result, name, array, property) {
      var filterType = array[name];

      // If select all, just return true
      if (this.selectedFilters[name].length == 0) {
        return true;
      }
      // If the filter type doesn't even exist, just return false
      if (!filterType) {
        return false;
      }

      // For consistency, let's make sure each filter type is an array
      if (!filterType.length) {
        filterType = [filterType];
      }

      if (filterType) {
        if (property) {
          result = filterType.some(
            el =>
              this.selectedFilters[name].indexOf(el[property]) !== -1 ||
              this.selectedFilters[name].indexOf(formatId(el[property])) !== -1
          );
        } else {
          result = filterType.some(
            el =>
              this.selectedFilters[name].indexOf(el) !== -1 ||
              this.selectedFilters[name].indexOf(formatId(el)) !== -1
          );
        }
      }

      return result;
    },
    mergeKeywords: function() {
      // break the profile name apart and add it to list of keywords
      let profiles = this.liveProfileData.fsprofiles;

      for (var i = 0; i < profiles.length; i++) {
        let profileName = profiles[i].name.split(" ");
        let profileKeywords = profiles[i].areasOfInterest + ",";

        for (var ii = 0; ii < profileName.length; ii++) {
          profileKeywords += profileName[ii] + ",";
        }
        profiles[i].keywords = profileKeywords;
        // then tack on the jobTitle
        profiles[i].keywords += "," + profiles[i].jobTitle;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PeopleDirectory.vue